import { Location } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Discount } from '@src/app/ecom-models/discount';
import { Reward } from '@src/app/ecom-models/reward';
import { User } from '@src/app/ecom-models/user';
import { EcomCartService } from '@src/app/ecom-services/ecom-cart.service';
import { EcomSettingService } from '@src/app/ecom-services/ecom-setting.service';
import { ToastService } from '@src/app/toast/toast.service';
import { Base64 } from 'js-base64';
import { AlertComponent } from 'ngx-bootstrap/alert';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { EcomNetworkUtils } from 'src/app/ecom-base-entities/ecom-shared/ecom-networkutils.service';
import { ModifierSetBase } from 'src/app/ecom-base-entities/ecom-stores-base/ecom-item-base/ecom-modifersetbase';
import { ModifierSetOptionBase } from 'src/app/ecom-base-entities/ecom-stores-base/ecom-item-base/ecom-modifieroptionbase';
import { StoreServiceBase } from 'src/app/ecom-base-entities/ecom-stores-base/ecom-storeservicebase';
import { UserServiceBase } from 'src/app/ecom-base-entities/ecom-stores-base/ecom-userservicebase';
import { EComService } from 'src/app/ecom-services/ecom-common.service';
import { EComWebStorage } from 'src/app/ecom-services/ecom-webstorage.services';
import { default as olarconfig } from '../../../assets/olarconfig.json';
import { EcomCookies } from '../../ecom-services/ecom-cookies';
import { EcomDetailService } from '../ecom-item-details2/ecom-item-detail.service';
import { generateGuid, ItemBase } from './../../ecom-base-entities/ecom-stores-base/ecom-item-base/ecom-itembase';

@Component({
  selector: 'app-ecom-item-cart',
  templateUrl: './ecom-item-cart.component.html',
  styleUrls: ['./ecom-item-cart.component.scss']
})
export class EcomItemCartComponent implements OnInit {
  // component class properties
  environment: any;
  serviceType = 'DINE_IN';
  settings: any;
  locationSelected: any;

  userServiceBase: UserServiceBase;
  userSelectedStore: StoreServiceBase;
  cartErrorMessage = '';
  cartEmptyMessage: any;
  modalRef: BsModalRef;
  sessionModalRef: BsModalRef;

  //itemList = [];
  itemListAllCategory = [];
  servicechagePercentage: any;
  taxList = [];
  openForOrders = true;


  @ViewChild('sessionExpired', { static: true }) sessionExpired: ElementRef;
  configsessionExpired = {
    ignoreBackdropClick: true,
    keyboard: false,
    animated: true,
    class: 'modal-dialog-centered'
  };
  usertoken = false;
  promoCodeForm: FormGroup;
  promoError = '';
  promoList = [];
  promoApplied: any;
  username: any;
  usercontact: any;
  referredList = [];
  referralDiscountApplied = false;
  distance = 0;
  orderDatetime: any;

  warningMessage: any;
  higherDeliveryCharges = false;
  isDeliveryOkay = true;
  deliveryCharges = 0;
  googlePlaceSelected = '';
  searchTerm: string;


  savedAddressList = [];
  isRedeem: any = false;
  redeemAmount = 0;

  olarmePromotionApplied: any = undefined;

  OfferApplied = 'none';
  alerts: any[] = [{
    type: 'warning',
    msg: 'limit exceeds',
    timeout: 5000,
    isOpen: false
  }];
  AmountToPay = 0;
  OrderTotalAmountBeforeCashback = 0;
  cashbackpopupDisplayed = false;
  deliverynotInRange = false;
  deliveryNotes = 0;
  note1 = false;
  note2 = false;

  // dinein qr code 
  retrycount = 0;
  PaymentAmount = 0;
  redeemPoints: any;
  paymentPromocodeApplied = false;
  PaymentTypeSelectedName = '';
  areaList = [];
  active = 0;
  IsLocationQRCode = false;

  // order status popup
  @ViewChild('orderstatus', { static: true }) orderstatus: ElementRef;
  configorderstatus = {
    ignoreBackdropClick: true,
    keyboard: false,
    animated: true,
    class: 'modal-dialog-centered modal-sm'
  };
  orderstatusModalRef: BsModalRef;
  customer_order: any;
  upSellItems: any[] = [];
  defaultImage = './assets/images/Itemdefault.jpeg';
  itemIds: number[] = [];
  bsModalRef: BsModalRef;
  entireDiscount?: Discount;
  totalEntireDiscounts: number = 0;
  subTotal: number = 0;
  totalDiscount: number = 0;
  total: number = 0;
  totalTax: number = 0;
  serviceCharges: any[] = [];
  totalSurcharge: number = 0;
  totalSurchargeTax: number = 0;
  IsTableQRCode: number;
  surcharges: any[] = [];
  taxArray: any[] = [];
  qrCodeType = 1;
  toastMessage = "";
  showToast = false;

  discountWarningRef: BsModalRef;
  @ViewChild('discountWarning', { static: true }) discountWarning: ElementRef;
  handleGoAhead?: () => void;
  drawerVisible: boolean;

  rewardVisible: boolean;
  item_pkid: any;
  iscvsd_pkid: any;
  category_pkid: any;
  item: any;
  onClose?: () => void;
  itemIndex: number;
  allrewards: Reward[] = [];

  activeRewards: Reward[] = [];
  rewardMenu: any[];
  selectedMenuReward: string;
  filteredrewards: Reward[] = [];
  customerLoyalty: User;
  freeRewards: ItemBase[] = [];
  showModifierPopup: boolean;
  rewardDetails: Reward;

  modalRefRewardWarning: BsModalRef;
  @ViewChild('rewardWarning', { static: true }) rewardWarning: ElementRef;
  usedReward: boolean;
  seletecReward: Reward;

  rewardTermsModalRef!: BsModalRef;

  @ViewChild('rewardTermsModal', { static: true }) rewardTermsModal!: ElementRef;


  // constructor to inject the class objects
  constructor(public location: Location, public ecomservice: EComService, public router: Router, private webstorage: EComWebStorage,
    private modalService: BsModalService,
    public formBuilder: FormBuilder,
    public cookie: EcomCookies, private cartService: EcomCartService,
    private settingService: EcomSettingService,
    private toastService: ToastService,
    private itemDetailService: EcomDetailService,
    private translate: TranslateService) {
    this.environment = olarconfig.Environment;

    this.settingService.currentQRCodeType.subscribe(value => {
      this.IsTableQRCode = value;
      this.qrCodeType = value;
    });

    this.settingService.currentUserInfo.subscribe(value => {
      this.customerLoyalty = value;
    });

    this.settingService.currentLocationSetting.subscribe(settings => {
      this.settings = settings;
    });

    this.toastService.message$.subscribe(message => {
      this.toastMessage = message;
    });

    this.toastService.visibility$.subscribe(visible => {
      this.showToast = visible;
    });
    this.rewardMenu = [{
      key: 'WELCOME_BONUS',
      topText: 'Join',
      bottomText: 'Bonus'
    }, {
      key: 'BIRTHDAY_BONUS',
      topText: 'B\'day',
      bottomText: 'Gift'
    },
    {
      key: 'BENEFIT_COUNT',
      topText: 'Benefit',
      bottomText: 'Count'
    },
    {
      key: '0-50',
      topText: '50',
      bottomText: 'Points'
    },
    {
      key: '50-100',
      topText: '100',
      bottomText: 'Points'
    }, {
      key: '100',
      topText: 'Max',
      bottomText: 'Points'
    }];
    this.selectedMenuReward = "WELCOME_BONUS";

  }

  // component initialize and load the required data
  async ngOnInit() {
    //as per discussion with sir we need to hide dine-in word incase of storeQR code
    if (this.webstorage.sessionSt_qrcode_type && this.webstorage.sessionSt_qrcode_type === 'QRSTORE') {
      this.IsLocationQRCode = true;
    }
    this.active = 0;


    // check if the cart started an hour before then expire the session
    this.userServiceBase = this.settingService.getUserSerivce();

    if (!this.userServiceBase) {
      this.router.navigate(['home']);
      return;
    }
    if (this.userServiceBase && this.userServiceBase.serviceCartStarteddAt) {
      let date1 = new Date().getTime();
      let date2 = new Date(this.userServiceBase.serviceCartStarteddAt).getTime();
      let time = date1 - date2;  //msec
      let minutesDiff = Math.floor(time / 60000);
      minutesDiff = Number(minutesDiff.toFixed(0));
      //console.log('mins diff cart - ' + minutesDiff);
      let cartExpireInMins = Number(this.ecomservice.GetOlarConfigValue('cartexpiryInMins'));
      if (minutesDiff >= cartExpireInMins || NaN) {
        this.sessionModalRef = this.modalService.show(this.sessionExpired, this.configsessionExpired);
      }
    }

    this.username = this.webstorage.localSt_name;
    this.usercontact = this.webstorage.localSt_contact;
    this.usertoken = (this.cookie.cookie_authtoken && this.webstorage.localSt_user_id) ? true : false;
    //if (this.webstorage.sessionSt_frompage && this.webstorage.sessionSt_frompage === 'status') {
    //  this.router.navigate(['home']);
    //}
    this.webstorage.sessionSt_qr_scan_current_page = this.router.url;
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });

    if (!this.settingService.getCompanySetting()) {
      this.router.navigate(['home']);
    } else {

      if (this.webstorage.sessionSt_autoOpenReward) {
        this.viewReward();
      }

      this.LoadPage();

      const setting = this.settingService.getCompanySetting();
      if (setting.oocls_order_open) {
        this.openForOrders = true;
        //Check later
        //this.openForOrders = this.webstorage.sessionSt_store_open_for_orders === 'YES' ? true : false;
      }
      this.promoCodeForm = this.formBuilder.group({
        promocode: ['', Validators.compose([Validators.required])]
      });


      //checkout details
      if (this.webstorage.sessionSt_frompage && this.webstorage.sessionSt_frompage === 'items') {
        this.cookie.cookie_latlng_delivery_address_change = this.cookie.cookie_latlng;
      }

      this.username = this.webstorage.localSt_name ? this.webstorage.localSt_name : this.userServiceBase.userName;
      this.usercontact = this.webstorage.localSt_contact ? this.webstorage.localSt_contact : this.userServiceBase.userMobile;


      if (this.userSelectedStore && this.userSelectedStore.storeCart) {
        //this.recalculateTotalPrice(this.userSelectedStore);
        const userService = this.settingService.getUserSerivce();
        this.entireDiscount = userService.entireReward;
        await this.fetchEntireDiscounts();
        await this.fetchSurcharges();
        await this.fetchCustomerLoyalty();
        await this.fetchRewards();
        this.recalculateTotalPrice(this.userSelectedStore);
        this.fetchUpsellItems();
        this.getTotalAmountToPay(this.userSelectedStore.storeCart.orderTotal, 'ngOnInit');
      } else {
        this.getTotalAmountToPay(0, '');
      }
    }
  }

  recalculateTotalPrice(cart) {

    const data = cart.storeCart.orderItems;
    this.totalEntireDiscounts = 0;
    this.subTotal = 0;
    this.totalDiscount = 0;
    this.totalEntireDiscounts = 0;
    this.totalTax = 0;
    this.total = 0;
    this.taxArray = [];
    if (!data) return;

    this.cartEmptyMessage = "";
    let itemTaxs = {};
    const taxType = this.settings.company_sell_price_tax;
    let priceBeforeDiscount = 0;
    let totalDiscount = 0;
    //let taxAmount = 0;
    //let modTax = 0;



    data.forEach((item: ItemBase) => {
      if (item.isBuyItem) item.discountedPrice = item.HasModifier ? (item.totalPrice / item.quantity) : item.priceEach;
      this.cartService.calculateModifierPrice(item, taxType);
      //let res = this.cartService.calculatePrice((item.HasModifier ? item.totalPrice : item.priceEach) - item.discountAmount, item.tax.tax_rate, this.entireDiscount.discount_value, taxType, this.entireDiscount.discount_value_type);
      priceBeforeDiscount += item.priceEach * item.quantity;
      totalDiscount += item.quantity * item.discountAmount;

      const taxAmount = item.quantity * item.taxEach;

      itemTaxs = this.addTax(itemTaxs, item.tax, taxAmount);

      // Modifiers

      item.modifierSetList.forEach((modifier: ModifierSetBase) => {

        modifier.modifierOptions.filter(x => x.optionSelected).forEach((option: ModifierSetOptionBase) => {

          const modTax = item.quantity * option.optionTaxAmt;
          itemTaxs = this.addTax(itemTaxs, option.tax, modTax);
          priceBeforeDiscount += item.quantity * option.optionPrice;

          option.modifiers_into_modifier.filter(x => x.optionSelected).forEach((modInMod: ModifierSetOptionBase) => {
            //modTax += modInMod.optionTaxAmt;
            priceBeforeDiscount += item.quantity * modInMod.optionPrice;
          });

        });
      });


    });
    let entireDiscounts = 0;

    // Other lv dicount
    if (this.entireDiscount) {

      const { discount_minimum_requirement, discount_minimum_requirement_quantity, discount_minimum_requirement_amount, discount_value_type, discount_value } = this.entireDiscount;
      // Minimum Requirement
      // Quanity
      const quantity = data.reduce((sum, item) => sum + item.quantity, 0);
      if (discount_minimum_requirement === 'QUANTITY' && quantity >= discount_minimum_requirement_quantity) {
        itemTaxs = {}
        const { newTotalPrice, itemTaxObj, discountedAmount } = this.calculateEntireDiscount(discount_value_type, priceBeforeDiscount - totalDiscount, discount_value, data, this.entireDiscount.max_value);
        //totalPrice = newTotalPrice;
        itemTaxs = itemTaxObj;
        entireDiscounts = discountedAmount;
      }
      // Amount
      else if (discount_minimum_requirement === 'AMOUNT' && priceBeforeDiscount >= discount_minimum_requirement_amount) {
        itemTaxs = {}
        const { newTotalPrice, itemTaxObj, discountedAmount } = this.calculateEntireDiscount(discount_value_type, priceBeforeDiscount - totalDiscount, discount_value, data, this.entireDiscount.max_value);
        //totalPrice = newTotalPrice;
        itemTaxs = itemTaxObj;
        entireDiscounts = discountedAmount;
      }
      //None
      else if (discount_minimum_requirement === 'NONE') {
        itemTaxs = {}
        const { newTotalPrice, itemTaxObj, discountedAmount } = this.calculateEntireDiscount(discount_value_type, priceBeforeDiscount - totalDiscount, discount_value, data, this.entireDiscount.max_value);
        // totalPrice = newTotalPrice;
        itemTaxs = itemTaxObj;
        entireDiscounts = discountedAmount;
      }

    }

    if (this.surcharges.length > 0) {
      this.serviceCharges = [];
      let totalSurcharge = 0;
      let totalSurchargeTax = 0;
      let surchargeAmt = 0;
      let surchargeTax = 0;
      //console.log('surcharges:', surcharges);
      //if (!priceBeforeDiscount) return;

      this.surcharges.forEach(sur => {
        let obj: any;
        //After discount
        if (sur.surcharge_discount === "A") {
          if (taxType !== "TAX_EX") {
            surchargeAmt = (sur.surcharge_percentage / 100) * (priceBeforeDiscount - this.totalDiscount - this.totalEntireDiscounts);

            if (sur.tax_rate > 0) {

              surchargeTax = (sur.tax_rate / 100) * surchargeAmt;
              itemTaxs = this.addTax(itemTaxs, { tax_pkid: sur.tax_pkid, tax_name: sur.tax_name }, surchargeTax);
            }
            obj = {
              amountSurcharge: surchargeAmt,
              surchargeName: `${sur.surcharge_name} (${sur.surcharge_percentage}%)`,
              //surchargeTax
            }
          } else {
            const surchargeAmt = (sur.surcharge_percentage / 100) * (priceBeforeDiscount - totalDiscount - entireDiscounts);
            if (sur.tax_rate > 0) {

              const surchargeTax = (sur.tax_rate / 100) * surchargeAmt;
              itemTaxs = this.addTax(itemTaxs, { tax_pkid: sur.tax_pkid, tax_name: sur.tax_name }, surchargeTax);
            }
            obj = {
              amountSurcharge: surchargeAmt,
              surchargeName: `${sur.surcharge_name} (${sur.surcharge_percentage}%)`,
              //surchargeTax
            }
          }
          //totalSurcharge += surchargeAmt;
          //console.log("why", this.totalSurcharge)
          //this.totalSurchargeTax += surchargeTax;
        }
        //Before discount
        else {
          if (taxType === "TAX_IN") {
            surchargeAmt = (sur.surcharge_percentage / 100) * priceBeforeDiscount;
            if (sur.tax_rate) {
              const rate = sur.tax_rate / 100;
              surchargeTax = (surchargeAmt / (1 + rate)) * rate;
              itemTaxs = this.addTax(itemTaxs, { tax_pkid: sur.tax_pkid, tax_name: sur.tax_name }, surchargeTax);
            }
            obj = {
              amountSurcharge: surchargeAmt,
              surchargeName: `${sur.surcharge_name} (${sur.surcharge_percentage}%)`,
              //surchargeTax
            }
          } else {
            //const aa = this.subTotal
            surchargeAmt = (sur.surcharge_percentage / 100) * priceBeforeDiscount;

            if (sur.tax_rate) {
              surchargeTax = (sur.tax_rate / 100) * surchargeAmt;
              itemTaxs = this.addTax(itemTaxs, { tax_pkid: sur.tax_pkid, tax_name: sur.tax_name }, surchargeTax);
            }
            obj = {
              amountSurcharge: surchargeAmt,
              surchargeName: `${sur.surcharge_name} (${sur.surcharge_percentage}%)`,
              //surchargeTax
            }
          }
        }
        totalSurcharge += obj.amountSurcharge;
        totalSurchargeTax += obj.surchargeTax;

        obj.earn_points = sur.earn_points;
        this.serviceCharges.push(obj);
      });



      // this.subTotal = totalPrice;
      // this.totalDiscount = totalDiscount;
      // this.totalEntireDiscounts = entireDiscounts;
      // this.totalTax = taxAmount + modTax;
      // this.total = this.subTotal - this.totalDiscount - this.totalEntireDiscounts + totalSurcharge + totalSurchargeTax;
      // if (taxType === "TAX_EX") this.total = this.total + this.totalTax;

      // cart.storeCart.orderTotal = this.total;
    }

    this.taxArray = Object.entries(itemTaxs).map(([id, details]) => ({
      id: id,
      total: (details as any).total,
      taxName: (details as any).taxName
    })).filter(x => x.total > 0);

    const itemTax = this.taxArray.reduce((total, t) => total + t.total, 0);

    const totalSurcharge = this.serviceCharges.reduce((total, r) => total + r.amountSurcharge, 0);

    this.subTotal = priceBeforeDiscount;
    this.totalDiscount = Number((totalDiscount).toFixed(2));
    this.totalEntireDiscounts += Number((entireDiscounts).toFixed(2));
    this.totalTax = Number((itemTax).toFixed(2));
    this.total = Number((this.subTotal - this.totalDiscount - this.totalEntireDiscounts + totalSurcharge).toFixed(2));
    if (taxType === "TAX_EX") this.total = this.total + this.totalTax;

    cart.storeCart.orderTotal = Number((this.total).toFixed(2));;
    // Calculatepoint = 

    let totalEarningPoints = Number((this.total).toFixed(2));
    if (this.customerLoyalty.loyalty_tier) {
      const itemsNotEarningPoints = data.filter(x => !x.earning_points);
      let totalNotEarningPoints = 0;
      itemsNotEarningPoints.forEach((item: ItemBase) => {
        totalNotEarningPoints += item.priceEach * item.quantity;
      });

      let surchargesNotEarningPoints = 0;
      const surchargeNotEarningPoints = this.serviceCharges.filter(x => !x.earn_points);

      surchargeNotEarningPoints.forEach(su => {
        surchargesNotEarningPoints += su.amountSurcharge;
      });

      // If earnPointTaxMode is "B", points are calculated based on the pre-tax amount.
      // Therefore, tax must be excluded before calculating reward points.
      if (this.customerLoyalty.earnPointTaxMode === "B") {
        totalEarningPoints = totalEarningPoints - this.totalTax;
      }
      totalEarningPoints = totalEarningPoints - totalNotEarningPoints;
      const userService = this.settingService.getUserSerivce();
      userService.gainedPoints = 0;
      if (totalEarningPoints >= this.customerLoyalty.minOrderAmountForPoints) {
        const points = Math.floor((totalEarningPoints / this.customerLoyalty.amountUnit) * this.customerLoyalty.pointsPerUnit);
        console.log("POINT", points);
        const userService = this.settingService.getUserSerivce();
        userService.gainedPoints = points;

      }
      this.settingService.setUserSerivce(userService);
    }

  }


  calculateEntireDiscount(type: string, total: number, value: number, lst, maxDiscountAmount = 0) {
    const taxType = this.settings.company_sell_price_tax;
    let discountedAmount = 0;
    let discountPercent = 0;
    if (type === 'PERCENTAGE') {
      discountedAmount = (total * (value / 100));
      discountPercent = value
    } else if (type === 'AMOUNT') {
      discountPercent = (Math.min(value, total) / total) * 100;
      //discountedAmount = (total * (discountPercent / 100));
    }

    let totalPrice = 0;
    //const entireDiscount = discountedAmount;
    let totalDiscount = 0;
    let taxAmount = 0;
    let itemTaxObj = {};
    lst.forEach((item: ItemBase) => {
      const res = this.cartService.calculatePrice(item.priceEach - item.discountAmount, item.tax.tax_rate, discountPercent, taxType, "PERCENTAGE", maxDiscountAmount);
      totalPrice += res.price;
      totalDiscount += item.quantity * res.discountAmount;

      taxAmount = item.quantity * res.taxAmount;

      itemTaxObj = this.addTax(itemTaxObj, item.tax, taxAmount);

      // Modifiers
      let modTax = 0;

      item.modifierSetList.filter(x => x.modifierSetSelected).forEach((modifier: ModifierSetBase) => {

        modifier.modifierOptions.filter(x => x.optionSelected).forEach((option: ModifierSetOptionBase) => {

          const newPrice = this.cartService.calculatePrice(option.optionPrice, option.tax.tax_rate, discountPercent, taxType, "PERCENTAGE", maxDiscountAmount);
          modTax += item.quantity * newPrice.taxAmount;
          totalDiscount += item.quantity * newPrice.discountAmount;
          itemTaxObj = this.addTax(itemTaxObj, option.tax, item.quantity * newPrice.taxAmount);

          option.modifiers_into_modifier.filter(x => x.optionSelected).forEach((modInMod: ModifierSetOptionBase) => {
            modTax += modInMod.optionTaxAmt;

          });

        });
      });


    });

    return {
      newTotalPrice: totalPrice,
      itemTaxObj,
      discountedAmount: totalDiscount
    }

  }

  addTax(itemTaxObj, tax, taxAmount) {
    if (!itemTaxObj[tax.tax_pkid]) {
      itemTaxObj[tax.tax_pkid] = { total: 0, taxName: tax.tax_name };
    }

    // Cộng giá vào tổng
    itemTaxObj[tax.tax_pkid].total += taxAmount;

    return itemTaxObj;
  }


  async fetchEntireDiscounts() {
    if (this.entireDiscount && this.entireDiscount.rewardPkid) return;

    const companyId = this.settings.company_id;
    const locationPkid = this.locationSelected.mm_online_order_location_settings.ools_location_pkid;
    const response = await this.ecomservice.httpGet(`${EcomNetworkUtils.GET_ENTIRE_DISCOUNTS_BY_LOCATION_ID}?companyId=${companyId}&locationId=${locationPkid}`, '', false)
      .toPromise();
    if (response.status === 200 && response.listValue) {
      this.entireDiscount = new Discount(response.listValue);
      //this.recalculateTotalPrice(this.userSelectedStore);
    }

  }

  async fetchSurcharges() {


    const currentSurcharges = this.cartService.surcharges.getValue();
    if (currentSurcharges.length) return;

    const companyId = this.settings.company_id;
    const locationPkid = this.locationSelected.mm_online_order_location_settings.ools_location_pkid;
    const model = {
      type: this.serviceType,
      companyId,
      locationPkid
    }
    const response = await this.ecomservice.httpPost(`${EcomNetworkUtils.GET_SURCHARGES_BY_LOCATION_ID}`, model, '', false)
      .toPromise();
    if (response.status === 200) {
      //this.cartService.setSurcharges(response.listValues)
      this.surcharges = response.listValues;
      //this.recalculateTotalPrice(this.userSelectedStore);
    }

  }

  async fetchRewards() {

    const companyId = this.settings.company_id;
    const locationPkid = this.locationSelected.mm_online_order_location_settings.ools_location_pkid;
    const model = {
      type: this.serviceType,
      companyId,
      locationPkid,
      customer_pkid: this.customerLoyalty.userPkid
    }
    const response = await this.ecomservice.httpPost(`${EcomNetworkUtils.GET_OLAR_REWARDS}`, model, '', true)
      .toPromise();
    if (response.status === 200) {
      this.allrewards = response.listValues;
      const now = new Date();
      const month = now.getMonth() + 1;

      this.activeRewards = this.allrewards
        .filter(x =>
          (x.type !== "BENEFIT_COUNT" && x.type !== "BIRTHDAY_BONUS" && x.point <= this.customerLoyalty.points)
          || (x.type === "BENEFIT_COUNT" && x.is_assigned)
          || (x.type === "BIRTHDAY_BONUS" && month === this.customerLoyalty.month)
        )
        .sort((a, b) =>
          Number(b.type === "BIRTHDAY_BONUS") - Number(a.type === "BIRTHDAY_BONUS")
        );


      this.getFilteredRewards({ key: "WELCOME_BONUS" });
      //console.log(response.listValues)
    }

  }

  async fetchCustomerLoyalty() {

    const companyId = this.settings.company_id;
    const locationPkid = this.locationSelected.mm_online_order_location_settings.ools_location_pkid;
    const user = this.settingService.getUserInfo();
    const model = {
      type: this.serviceType,
      companyId,
      locationPkid,
      customer_pkid: user.userPkid
    }

    const response = await this.ecomservice.httpPost(`${EcomNetworkUtils.GET_OLAR_CUSTOMER_LOYALTY}`, model, '', true)
      .toPromise();
    if (response.isSuccess && response.listValue) {
      //this.customerLoyalty = response.listValue;
      const data = response.listValue;
      this.settingService.setUserInfo(new User({
        ...user,
        // firstName: data.first_name,
        // lastName: data.last_name,
        originPoints: data.points,
        points: data.points,
        loyalty_tier: data.loyalty_tier,
        amount: data.points && data.ratio ? Number(data.points / data.ratio) : 0,
        maximum_redemtion: data.maximum_redemtion,
        amountUnit: data.amountUnit,
        pointsPerUnit: data.pointsPerUnit,
        earnPointTaxMode: data.earnPointTaxMode,
        minOrderAmountForPoints: data.minOrderAmountForPoints,
        maxUses: data.maxUses,
        ratio: data.ratio,
        programCurrency: data.programCurrency,
        month: data.month,
        next_tier: data.next_tier,
        spend_more: data.spend_more
      }));

    }

  }

  hideRewardDetails() {
    this.rewardDetails = null;
  }

  viewRewardDetails(event, reward: Reward) {
    event.stopPropagation();
    this.rewardDetails = reward;
  }

  async ok() {
    this.usedReward = true;
    this.modalRefRewardWarning.hide();
    this.usedReward = true;
    this.checkReward(this.seletecReward);
  }

  async checkReward(reward: Reward) {

    if (!this.usedReward) {
      this.modalRefRewardWarning = this.modalService.show(this.rewardWarning, {
        animated: true,
        class: 'modal-dialog-centered modal-sm',
        ignoreBackdropClick: false,
        keyboard: true
      });
      this.seletecReward = reward;
      return;
    }

    if (this.customerLoyalty.points < reward.point) {
      this.toastService.show("You don't have enough points to apply this reward");
      return;
    }
    if (reward.apply_to === "ENTIRE_ORDER") {
      if (!this.userSelectedStore.storeCart.orderItems.length) {
        this.toastService.show("Please add items to cart!");
        return;
      }

      if (this.entireDiscount && !this.entireDiscount.rewardPkid) {
        this.toastService.show("This order has already used an entire order discount and cannot apply a reward!");
        return;
      }

      if (this.subTotal < reward.minimum_requirement_value) {
        this.toastService.show(`This discount code is valid for orders from ${reward.minimum_requirement_value.toFixed(2)} and above.`);
        return;
      }

      if (reward.value_type === 'AMOUNT') {
        this.openRewardTermsModal();
      }

      // Reuse entire order discount
      // AMOUNT NO MIN NO MAX      
      const discount = new Discount({
        discount_minimum_requirement: "AMOUNT",
        discount_minimum_requirement_amount: reward.value_type === "AMOUNT" ? 0 : reward.minimum_requirement_value,
        discount_value_type: reward.value_type,
        discount_value: reward.reward_value,
        max_value: reward.value_type === "AMOUNT" ? 0 : reward.max_value,
        rewardPkid: reward.reward_pkid,
        point: reward.point
      });

      const userService = this.settingService.getUserSerivce();
      userService.entireReward = discount
      this.settingService.setUserSerivce(userService);

      this.entireDiscount = discount;

      this.closeRewardPopup();
      this.recalculateTotalPrice(this.userSelectedStore);
      this.toastService.show("Your reward has been applied");

      return;

    }



    if (reward.type === "FREE_PRODUCT") {

      const foundOrderItem = this.userSelectedStore.storeCart.orderItems.find(item =>
        !item.hasReward &&
        !item.discounted &&
        item.variantList &&
        item.variantList.length > 0 &&
        reward.item_pkid == +item.variantList[0].variantGuid
      );
      if (!foundOrderItem) {
        //this.toastService.show("To use this reward, your cart must include at least one eligible item");

        const getItems = await this.fetchItemsByIds([reward.item_pkid]);

        for (const rItem of getItems) {
          rItem.reward = reward;
        }
        console.log(getItems);
        this.freeRewards = getItems;

        if (getItems && getItems.length > 0) {
          const item = getItems[0];
          this.showModifierPopup = item.modifierSetList.length > 0;
          if (!this.showModifierPopup) this.addCombinationToCart();
        }

        return;
      }


      this.cartService.refreshCartItem(+foundOrderItem.itemGuid, this.locationSelected.mm_online_order_location_settings.ools_location_pkid, reward);

      //this.cartService.updateCart(item, this.locationSelected.mm_online_order_location_settings.ools_location_pkid);
      this.closeRewardPopup();
      this.recalculateTotalPrice(this.userSelectedStore);

    }

    if (reward.type === "BENEFIT_COUNT" && reward.value_type == "FREE") {

      const foundOrderItem = this.userSelectedStore.storeCart.orderItems.find(item =>
        !item.hasReward &&
        !item.discounted &&
        item.variantList &&
        item.variantList.length > 0 &&
        reward.item_pkid == +item.variantList[0].variantGuid
      );
      if (!foundOrderItem) {
        this.toastService.show("To use this reward, your cart must include at least one eligible item");
        return;
      }


      this.cartService.refreshCartItem(+foundOrderItem.itemGuid, this.locationSelected.mm_online_order_location_settings.ools_location_pkid, reward);

      //this.cartService.updateCart(item, this.locationSelected.mm_online_order_location_settings.ools_location_pkid);
      this.closeRewardPopup();
      this.recalculateTotalPrice(this.userSelectedStore);


    }

    if (reward.type === "BENEFIT_COUNT" && reward.value_type == "DISCOUNT") {

      const foundOrderItem = this.userSelectedStore.storeCart.orderItems.find(item =>
        !item.hasReward &&
        !item.discounted &&
        item.variantList &&
        item.variantList.length > 0 &&
        reward.item_pkid == +item.variantList[0].variantGuid
      );
      if (!foundOrderItem) {
        this.toastService.show("To use this reward, your cart must include at least one eligible item");
        return;
      }


      this.cartService.refreshCartItem(+foundOrderItem.itemGuid, this.locationSelected.mm_online_order_location_settings.ools_location_pkid, reward);

      //this.cartService.updateCart(item, this.locationSelected.mm_online_order_location_settings.ools_location_pkid);
      this.closeRewardPopup();
      this.recalculateTotalPrice(this.userSelectedStore);
      this.toastService.show("Your reward has been applied");


    }

    if (reward.type === "WELCOME_BONUS") {
      const foundOrderItem = this.userSelectedStore.storeCart.orderItems.find(item =>
        !item.hasReward &&
        !item.discounted &&
        item.variantList &&
        item.variantList.length > 0 &&
        reward.item_pkid == +item.variantList[0].variantGuid
      );
      if (!foundOrderItem) {
        this.toastService.show("To use this reward, your cart must include at least one eligible item");
        return;
      }


      this.cartService.refreshCartItem(+foundOrderItem.itemGuid, this.locationSelected.mm_online_order_location_settings.ools_location_pkid, reward);

      this.closeRewardPopup();
      this.recalculateTotalPrice(this.userSelectedStore);
      this.toastService.show("Your reward has been applied");


    }


    if (['PERCENTAGE', 'AMOUNT'].includes(reward.value_type)) {
      const itemCartIds = this.userSelectedStore.storeCart.orderItems
        .map(order => order.variantList.map(v => v.variantGuid))
        .reduce((all, guids) => all.concat(guids), []);


      const canApplyReward = itemCartIds.some(item => +item === reward.item_pkid);
      if (!canApplyReward) {
        this.toastService.show("To use this reward, your cart must include at least one eligible item");
        return;
      }

      if (reward.value_type === 'AMOUNT') {
        this.openRewardTermsModal();
      }

      const foundOrderItemIds = this.userSelectedStore.storeCart.orderItems.find(item =>
        !item.hasReward &&
        !item.discounted &&
        item.variantList &&
        item.variantList.length > 0 &&
        reward.item_pkid == +item.variantList[0].variantGuid
      );

      if (foundOrderItemIds) {

        if (reward.apply_to === "SPECIFIC_ITEM") {
          reward.max_value = 0;
        }
        this.cartService.refreshCartItem(+foundOrderItemIds.itemGuid, this.locationSelected.mm_online_order_location_settings.ools_location_pkid, reward);

        //this.cartService.updateCart(item, this.locationSelected.mm_online_order_location_settings.ools_location_pkid);
        this.closeRewardPopup();
        this.recalculateTotalPrice(this.userSelectedStore);
        this.toastService.show("Your reward has been applied");
      }

    }

    //this.toastService.show("Your reward has been applied");
    this.updateRewardPoints();
  }

  onModifierSetClick3(item: any, modifier: any, index: number) {
    //console.log(item);
    item.modifierSetList[0].collapsed = !modifier.collapsed
    //modifier.collapsed = !modifier.collapsed;
  }

  onCombinationModifierOptionChecked(event, item: ItemBase, modifier, option, modifierIndex, optionIndex, itemIndex, modifersIntoModifier = false) {
    //modifier.collapsed = event.target.checked;
    //console.log(item.itemName);
    //console.log(itemIndex, modifierIndex, optionIndex);

    if (event.target.checked) {
      //if (modifersIntoModifier) {
      modifier.modifierOptions[optionIndex].selectedOptions.push(`${item.itemName}-${option.optionName}`);
      modifier.modifierOptions[optionIndex].selectedOptionIds.push(option.optionPkid);
      // }

      const status = this.onCombinationModiferOptionClick(item, modifier, option, 'PLUS', modifierIndex, optionIndex, modifersIntoModifier);
      event.target.checked = status;

    } else {
      modifier.modifierOptions[optionIndex].selectedOptions = modifier.modifierOptions[optionIndex].selectedOptions.filter(x => x !== option.optionName);
      modifier.modifierOptions[optionIndex].selectedOptionIds = modifier.modifierOptions[optionIndex].selectedOptions.filter(x => x !== option.optionPkid);
      //}
      this.onCombinationModiferOptionClick(item, modifier, option, 'MINUS', modifierIndex, optionIndex, modifersIntoModifier);

    }
  }

  onCombinationModiferOptionClick(item: ItemBase, modifier, option, type, modifierIndex, optionIndex, modifersIntoModifier) {
    //console.log("onCombinationModiferOptionClick", item.itemName)
    option.optionSelected = type === "PLUS";
    item.modifierSetList[modifierIndex].errorMessage = '';
    const qtyOption = Number(option.optionQuantity);
    let qtyModifierSet = Number(modifier.quantity);
    const qtyModifierSetMax = Number(modifier.modifierSetMax) * item.quantity;
    const qtyModifierSetMin = Number(modifier.modifierSetMin) * item.quantity;
    const preselect = option.optionPreSelected;

    let itemModifierPrice = 0;
    let optionPrice = 0;

    let mods = [];
    const arr = [];
    const ids = [];
    if (modifersIntoModifier) {
      optionPrice = option.optionPrice;
      mods = option.modifiers_into_modifier.filter(x => option.selectedOptionIds.includes(x.optionPkid)).map(x => x.optionPrice);
      if (!mods.length) optionPrice = 0;

      const idArr = option.modifiers_into_modifier.filter(x => option.selectedOptionIds.includes(x.optionPkid)).map(x => x.optionPkid);
      if (idArr.length) ids.push(idArr);
    }
    else {
      item.modifierSetList.forEach(set => {
        const p = set.modifierOptions.filter(x => x.optionSelected).map(x => x.optionPrice);
        if (p.length) arr.push(p);
        const idArr = set.modifierOptions.filter(x => x.optionSelected).map(x => x.optionPkid);
        if (idArr.length) ids.push(idArr);
      });

    }

    for (const subArray of arr) {
      for (const num of subArray) {
        mods.push(num);
      }
    }
    const idMod = [];
    for (const subArray of ids) {
      for (const num of subArray) {
        idMod.push(num);
      }
    }
    const modId = idMod.join('-');

    item.itemModId = `${item.itemGuid}-${modId}`;

    let totalModifiersPrice = 0;
    if (mods.length) {
      totalModifiersPrice = mods.reduce((total, modifier) => total + modifier, 0);

    }
    itemModifierPrice = optionPrice + totalModifiersPrice;


    if (type === 'PLUS') {
      if (qtyModifierSetMax > 0 && qtyModifierSet >= qtyModifierSetMax) {
        item.modifierSetList[modifierIndex].errorMessage = 'per qty allowed only ' + Number(item.modifierSetList[modifierIndex].modifierSetMax) + ' options';
        return false;
      } else {
        option.optionQuantity = qtyOption + (1 * item.quantity);
        item.modifierSetList[modifierIndex].quantity = qtyModifierSet + (1 * item.quantity);
        //option.optionSelected = true;
        item.priceEach = item.priceEach;
        if (item.HasModifier) item.itemModifierPrice = itemModifierPrice;
      }
    } else {
      if (qtyOption > 0) {
        item.priceEach = item.priceEach;
        if (item.HasModifier) item.itemModifierPrice = itemModifierPrice;
        // this.itemDetails.taxEach = this.itemDetails.taxEach - optiontaxAmt;
        //option.optionSelected = false;
        option.optionQuantity = qtyOption - (1 * item.quantity);
        if (qtyModifierSet > 0) {
          item.modifierSetList[modifierIndex].quantity = qtyModifierSet - (1 * item.quantity);
        }
      }
    }

    qtyModifierSet = Number(item.modifierSetList[modifierIndex].quantity);

    item.modifierSetList[modifierIndex].modifierSetSelected = qtyModifierSet > 0;

    // get selected variant
    //let variantIndex = -1;
    const variantSelected = item.variantList.find(x => x.selected);
    if (!variantSelected) return;
    // // update the total price
    item.totalPrice = variantSelected.variantQty * (item.priceEach + item.itemModifierPrice);

    return true;
  }

  addCombinationToCart() {

    const items = this.itemDetailService.mergeCartItems(this.freeRewards);
    let parentGuid = generateGuid();;
    items.forEach((item, index) => {
      item.hasReward = true;
      if (index === 0) {
        item.guid = parentGuid;
      }
      else {
        item.canRemove = false;
        item.parentGuid = parentGuid;
      }

      this.cartService.updateCart(item, this.locationSelected.mm_online_order_location_settings.ools_location_pkid);
    })

    this.showModifierPopup = false;
    this.closeRewardPopup();
    this.toastService.show("Your reward has been applied");
  }


  async fetchItemsByIds(ids: number[]) {
    const companyId = this.settings.company_id;
    const locationPkid = this.locationSelected.mm_online_order_location_settings.ools_location_pkid;
    const response = await this.ecomservice.httpPost(`${EcomNetworkUtils.GET_ITEMS_FREE_BY_IDS}`, { companyId: companyId, ids: ids, locationPkid: locationPkid }, '', false)
      .toPromise();
    this.ecomservice.loadingPage.loading = false;

    if (response.status === 200 && response.listValues.length) {
      const items = response.listValues.map(item => {
        return this.itemDetailService.mapItemBase(item);
      });
      return items
    }
    return [];

  }


  fetchUpsellItems() {
    if (!this.userSelectedStore || !this.userSelectedStore.storeCart.orderItems || !this.userSelectedStore.storeCart.orderItems.length) return;

    this.itemIds = this.userSelectedStore.storeCart.orderItems.map(x => +x.itemGuid);
  }

  customize(data, i: number) {
    this.openDetailDrawer(data, i);
    // const modalOptions = {
    //   class: 'col-xl-4 col-lg-5 col-md-6 col-sm-12 col-12',
    //   initialState: {
    //     // Truyền function vào initialState
    //     onClose: this.closeCustomize.bind(this),
    //     item: data
    //   }
    // };
    // this.bsModalRef = this.modalService.show(EcomItemDetailsPopupComponent, modalOptions);

  }

  openDetailDrawer(item, i: number) {
    this.itemIndex = i;
    this.drawerVisible = true;
    this.item = item;
    this.onClose = this.onDrawerVisibleChange.bind(this, item);
    this.item_pkid = item.itemGuid;
    this.iscvsd_pkid = item.ooip_iscvsd_pkid;
    this.category_pkid = null;
  }

  onDrawerVisibleChange(changedItem: ItemBase) {
    this.drawerVisible = false;
    changedItem.discountedPrice = changedItem.priceEach;
    if (changedItem.HasModifier) {
      const itemPrice = changedItem.priceEach;
      const modPrice = changedItem.itemModifierPrice;
      const total = (itemPrice + modPrice) - changedItem.discountAmount;
      changedItem.discountedPrice = total;
    }

    this.userSelectedStore.storeCart.orderItems[this.itemIndex] = changedItem;
    this.settingService.setUserSerivce(this.userServiceBase);
    this.recalculateTotalPrice(this.userSelectedStore);


  }


  closeRewardPopup() {
    this.rewardVisible = false;
    this.showModifierPopup = false;

    if (this.webstorage.sessionSt_autoOpenReward) {
      this.onBackClick();
      this.webstorage.sessionSt_autoOpenReward = false;
    }
  }

  closeCustomize() {
    //this.updateCart1(this.webstorage.sessionSt_cart_item);
    this.bsModalRef.hide();
  }
  onCheckStatusClick() {
    let servicetype = this.webstorage.sessionSt_service_type;
    var companyid = this.webstorage.sessionSt_location_selected.oocls_company_id;
    if (servicetype === 'DINE_IN') {
      this.router.navigate(['status-dinein'], { queryParams: { companyId: companyid, serviceId: this.customer_order['ooco_oodcdr_guid'] } });
    } else if (servicetype === 'COLLECTION') {
      this.router.navigate(['status-collection'], { queryParams: { companyId: companyid, serviceId: this.customer_order['ooco_oodcdr_guid'] } });
    } else if (servicetype === 'DELIVERY') {
      this.router.navigate(['status-delivery'], { queryParams: { companyId: companyid, serviceId: this.customer_order['ooco_oodcdr_guid'] } });
    }
    this.webstorage.sessionSt_user_order_reference = undefined;
    this.orderstatusModalRef.hide();
  }

  getTotalAmountToPay(orderTotal, method) {
    if (!this.userSelectedStore.storeCart || orderTotal === 0) {
      this.AmountToPay = 0;
      this.OrderTotalAmountBeforeCashback = 0;
      return;
    }


    this.recalculateTotalPrice(this.userSelectedStore);
  }

  LoadPage() {
    if (!this.webstorage.localSt_client_id || !this.webstorage.localSt_olar_key) {
      const url = EcomNetworkUtils.POST_GENERATEKEY;
      this.ecomservice.httpPost(url, {}, '', true).subscribe((response) => {
        if (response.isSuccess) {
          if (!this.webstorage.localSt_client_id) {
            this.webstorage.localSt_client_id = response.listValue.oock_client_id;
          }
          // store public key
          this.webstorage.localSt_olar_key = response.listValue.oock_public_key;
          this.initPage();
        }
      });
    } else {
      this.initPage();
    }
  }
  handleUpsellItem() {
    this.userServiceBase = this.settingService.getUserSerivce();
    const selectedStore = this.userServiceBase.selectedStoreServiceList.find(obj =>
      obj.locationPkid === this.locationSelected.mm_online_order_location_settings.ools_location_pkid
      && obj.serviceType === this.serviceType);
    if (selectedStore) {
      this.userSelectedStore = selectedStore;
      //console.log(222, this.userSelectedStore.storeCart.orderItems.length);
      this.recalculateTotalPrice(this.userSelectedStore);
    }
  }
  initPage() {
    this.locationSelected = this.settingService.getLocationSetting();;
    if (this.locationSelected) {
      var encoded = Base64.encode(this.locationSelected.company_id);
      this.location.replaceState(this.location.path(), '?webcompanyid=' + encoded);
    }
    this.cartEmptyMessage = '';
    this.serviceType = this.settingService.getCompanySetting().serviceType;
    //this.settings = this.webstorage.sessionSt_settings;

    this.userServiceBase = this.settingService.getUserSerivce();
    if (!this.userServiceBase.selectedStoreServiceList || this.userServiceBase.selectedStoreServiceList.length === 0) {
      this.router.navigate(['stores']);
      return;
    }
    if (this.webstorage.sessionSt_item_list) {
      this.itemListAllCategory = this.webstorage.sessionSt_item_list;
    } else {
      //this.getCategoryItems();
    }
    let serviceActiveId = this.webstorage.sessionSt_service_active_id;
    if ((this.webstorage.sessionSt_qr_code_scanned && this.webstorage.sessionSt_qr_code_scanned === true) || (this.webstorage.sessionSt_weburl_order && this.webstorage.sessionSt_weburl_order === true)) {
      serviceActiveId = 1;
    }
    if (!this.userServiceBase) {
      this.router.navigate(['stores']);
    } else {
      let userStoreIndex = -1;
      const selectedStore = this.userServiceBase.selectedStoreServiceList.find((obj, index) => {
        userStoreIndex = index;
        return obj.locationPkid === this.locationSelected.mm_online_order_location_settings.ools_location_pkid
          && obj.serviceType === this.serviceType
          && !obj.serviceCompleted;
      });
      if (selectedStore) {
        this.distance = Number(this.locationSelected.distance);
        this.orderDatetime = this.getOrderDatetimeFormat(selectedStore.serviceDatetime);
        this.userServiceBase.selectedStoreServiceList[userStoreIndex].serviceLocationName = selectedStore.serviceLocationName;
        this.userServiceBase.selectedStoreServiceList[userStoreIndex].serviceCompanyName = this.settings.company_name;

        this.userSelectedStore = selectedStore;

        // clear discounts if any applied previously
        if (this.userSelectedStore.storeCart && this.userSelectedStore.storeCart.orderItems && this.userSelectedStore.storeCart.orderItems.length > 0) {
          this.userSelectedStore.storeCart.olarDiscounts = [];
          this.userSelectedStore.storeCart.orderDiscountReferral = 0;
          this.userSelectedStore.storeCart.referral = null;
          // remove the error message related to items initially
          this.userSelectedStore.storeCart.orderItems.forEach(element => {
            element.itemError = '';
          });
          this.userSelectedStore.storeCart.orderId = this.getOrderID();
          // update back the details to local storage
          this.userServiceBase.selectedStoreServiceList[userStoreIndex].storeCart.orderId = this.userSelectedStore.storeCart.orderId;

          if (this.webstorage.sessionSt_cart_item !== null) {

          }

          this.settingService.setUserSerivce(this.userServiceBase);

          // tax type based on company tax type selection made
          const taxtype = this.settings.company_sell_price_tax;

          // tax list
          if (this.userSelectedStore && this.userSelectedStore.storeCart) {
            //this.getTaxList(this.userSelectedStore.storeCart.orderItems, deliveryAmount);

            this.getTotalAmountToPay(this.userSelectedStore.storeCart.orderTotal, 'initPage');
          } else {
            this.getTotalAmountToPay(0, '');
          }

        } else {
          this.translate.get('CART_PAGE.CART_EMPTY').subscribe(message => {
            this.cartEmptyMessage = message;
          });
        }
      } else {
        this.router.navigate(['stores']);
      }
    }

  }

  // Method to calculat the tax
  calculateTax(type, price, taxRate) {
    let taxAmount = 0;
    if (type === 'TAX_IN') {
      // Actual Price = (AmountX100)/(TaxRate+100)
      // Tax Rate = Amount -  ActualPrice
      const ActualPrice = Number(((price * 100) / (taxRate + 100)).toFixed(4));
      taxAmount = price - ActualPrice;
    } else {
      taxAmount = (taxRate / 100) * price;
    }
    return Number(taxAmount.toFixed(4));
  }


  // Method to check and appent zero
  checkZero(data) {
    if (data.length === 1) {
      data = '0' + data;
    }
    return data;
  }

  // Method to handle the back button click
  onBackClick() {
    this.settingService.setUserSerivce(this.userServiceBase);
    this.webstorage.sessionSt_frompage = 'cart';
    this.router.navigate(['items', this.webstorage.sessionSt_company_clicked]);
  }

  async viewReward() {
    this.rewardVisible = true;

    this.updateRewardPoints();
  }

  get totalPoints(): number {
    return this.customerLoyalty.originPoints - this.usedPoints;
  }

  get loyaltyAmount(): number {
    this.updateRewardPoints();
    const user = this.settingService.getUserInfo();
    if (user && user.userPkid > 0) {
      const amount = user.points && user.ratio ? Number(this.totalPoints / user.ratio) : 0;
      return amount;
    }
    return 0;
  }

  get usedPoints(): number {
    let point = 0;
    if (!this.userSelectedStore || !this.userSelectedStore.storeCart || !this.userSelectedStore.storeCart.orderItems) return 0;

    const userService = this.settingService.getUserSerivce();

    if (userService && userService.entireReward) {
      point = userService.entireReward.point;
    }

    const totalRewardPoints = this.userSelectedStore.storeCart.orderItems
      .filter(item => item.hasReward)
      .reduce((total, item) => total + item.reward.point, 0);

    return totalRewardPoints + point;
  }

  updateRewardPoints() {

    if (this.entireDiscount && this.entireDiscount.rewardPkid) {
      const re = this.activeRewards.find(x => x.reward_pkid === this.entireDiscount.rewardPkid)
      if (re) {
        re.is_redeemed = true;
        this.customerLoyalty.points = this.customerLoyalty.points - re.point;
        this.activeRewards = [...this.activeRewards];
      }
    }

    if (!this.userSelectedStore || !this.userSelectedStore.storeCart || !this.userSelectedStore.storeCart.orderItems) return;

    const selectedRewards = this.userSelectedStore.storeCart.orderItems.filter(item =>
      item.hasReward).map(x => x.reward);

    if (!selectedRewards.length) return;


    let startingPoints = this.customerLoyalty.originPoints;
    this.customerLoyalty.points = this.customerLoyalty.originPoints;
    selectedRewards.forEach(r => {
      this.customerLoyalty.points = this.customerLoyalty.points - r.point;
    });
    const rewardPkids = selectedRewards.map(x => x.reward_pkid);
    const spentsPoints = startingPoints - this.customerLoyalty.points;
    const userService = this.settingService.getUserSerivce();
    userService.spentsPoints = spentsPoints;
    userService.rewardPkidRedeemed = rewardPkids.join(', ');

    this.settingService.setUserSerivce(userService);

    this.settingService.setUserInfo(this.customerLoyalty);

    const filtered = this.activeRewards.filter(itemB =>
      selectedRewards.some(itemA =>
        itemA.reward_pkid === itemB.reward_pkid && itemA.item_pkid === itemB.item_pkid
      )
    );

    filtered.forEach(x => x.is_redeemed = true);

    this.activeRewards.forEach(r => {
      if (r.type === "WELCOME_BONUS") {
        r.is_redeemed = true;
      }
    })

    if (selectedRewards.length === this.customerLoyalty.maxUses) {
      this.activeRewards.forEach(r => {
        r.is_redeemed = true;
      })

      this.activeRewards = [...this.activeRewards];
      return;
    }


    this.activeRewards = [...this.activeRewards];
  }

  getFilteredRewards(menu) {
    //console.log(menu)
    this.selectedMenuReward = menu.key;
    switch (menu.key) {
      case "BENEFIT_COUNT":
        this.filteredrewards = this.allrewards.filter(
          item => item.type === "BENEFIT_COUNT" && !item.is_assigned
        );
        break;

      case "BIRTHDAY_BONUS":
        const now = new Date();
        const month = now.getMonth() + 1;
        this.filteredrewards = this.allrewards.filter(
          item => item.type === "BIRTHDAY_BONUS" && this.customerLoyalty.month !== month);
        break;

      case "0-50":
        this.filteredrewards = this.allrewards.filter(
          item => item.type !== "BENEFIT_COUNT" && item.point >= 0 && item.point <= 50
            && item.point > this.customerLoyalty.points
        );
        break;

      case "50-100":
        this.filteredrewards = this.allrewards.filter(
          item => item.type !== "BENEFIT_COUNT" && item.point >= 50 && item.point <= 100
            && item.point > this.customerLoyalty.points
        );
        break;

      case "100":
        this.filteredrewards = this.allrewards.filter(
          item => item.type !== "BENEFIT_COUNT" && item.point >= 100
            && item.point > this.customerLoyalty.points
        );
        break;

      default:
        this.filteredrewards = this.allrewards.filter(item => item.type === menu.key
          && item.point > this.customerLoyalty.points
        );
        break;
    }
  }


  onQuantityChange(type: string, item: ItemBase, index: number) {
    if (item.discounted) {
      this.discountWarningRef = this.modalService.show(this.discountWarning, this.configorderstatus);
      this.handleGoAhead = () => {
        //const discounts = this.settingService.getDiscounts();
        //const selectedDiscount = discounts.find(x => x.discount_pkid === item.selectedDiscountId);
        //if (selectedDiscount.limitReached) this.toastService.show(`Sorry, you’ve reached the maximum use for this discount`);
        if (type === "MINUS") {
          if (item.selectedDiscountId > 0)
            this.updateMaxUsersPerOrder(item, false);

          item.discountAmount = 0;
          item.discountedPrice = item.originalItem.discountedPrice;
          item.discounted = false;
          item.originalItem.selectedDiscountId = item.selectedDiscountId;
          item.selectedDiscountId = 0;
        }
        this.onItemClick(type, item, index);
        this.userServiceBase = this.settingService.getUserSerivce();
        let userStoreIndex = -1;
        let selectedStore = this.userServiceBase.selectedStoreServiceList.find((obj, index) => {
          userStoreIndex = index;
          return obj.locationPkid === this.locationSelected.mm_online_order_location_settings.ools_location_pkid && obj.serviceType === this.serviceType && !obj.serviceCompleted;
        });

        selectedStore.userConfirmedChange = true;
        this.settingService.setUserSerivce(this.userServiceBase);
      };
    } else {
      this.onItemClick(type, item, index);
    }
  }

  cancel() {
    this.discountWarningRef.hide();
  }

  goAhead() {
    this.discountWarningRef.hide();
    this.handleGoAhead();
  }

  recalculateDiscounts() {
    this.userServiceBase = this.settingService.getUserSerivce();
    let userStoreIndex = -1;
    let selectedStore = this.userServiceBase.selectedStoreServiceList.find((obj, index) => {
      userStoreIndex = index;
      return obj.locationPkid === this.locationSelected.mm_online_order_location_settings.ools_location_pkid && obj.serviceType === this.serviceType && !obj.serviceCompleted;
    });

    //console.log(selectedStore.storeCart.orderItems);

    if (selectedStore.storeCart.orderItems.length > 0) {
      selectedStore.storeCart.orderItems.forEach((element, i) => {
        element.index = i;
      })
    }

    debugger
    const items = selectedStore.storeCart.orderItems.filter(x => !x.discounted);

    if (!items.length) {
      this.recalculateTotalPrice(this.userSelectedStore);

      this.toastService.show(`Your discounts have been applied successfully!`);
      return;
    }

    items.forEach(element => {
      selectedStore.storeCart.orderItems = selectedStore.storeCart.orderItems.filter(x => x.guid !== element.guid);
      this.settingService.setUserSerivce(this.userServiceBase);
      element.selectedDiscountId = element.originalItem.selectedDiscountId;
      this.cartService.updateCart(element, this.locationSelected.mm_online_order_location_settings.ools_location_pkid);

    });
    selectedStore.storeCart.orderItems.sort((a, b) => a.index - b.index);
    selectedStore.userConfirmedChange = false;
    this.settingService.setUserSerivce(this.userServiceBase);
    this.recalculateTotalPrice(this.userSelectedStore);

    this.toastService.show(`Your discounts have been applied successfully!`)

  }

  // Method to handle the item click event
  onItemClick(type: string, item: ItemBase, ind) {

    //console.log("item", item);
    //console.log('onItemClick' + type);
    //console.log(item.ItemVariantModifierSetOptionGuid);
    this.cartErrorMessage = '';
    let itemadderror = false;
    let serviceActiveId = this.webstorage.sessionSt_service_active_id;
    if ((this.webstorage.sessionSt_qr_code_scanned && this.webstorage.sessionSt_qr_code_scanned === true) || (this.webstorage.sessionSt_weburl_order && this.webstorage.sessionSt_weburl_order === true)) {
      serviceActiveId = 1;
    }
    this.userServiceBase = this.settingService.getUserSerivce();
    let userStoreIndex = -1;
    let selectedStore = this.userServiceBase.selectedStoreServiceList.find((obj, index) => {
      userStoreIndex = index;
      return obj.locationPkid === this.locationSelected.mm_online_order_location_settings.ools_location_pkid && obj.serviceType === this.serviceType && !obj.serviceCompleted;
    });

    //console.log('----------------------------');
    //console.log(selectedStore.storeCart.orderItems);
    //console.log('----------------------------');
    //let cartitemindex = -1;
    let selectedItem = selectedStore.storeCart.orderItems.find(obj => obj.guid === item.guid);

    if (type === 'PLUS') {
      if (selectedItem) {
        selectedItem.itemError = '';
        const maxPerOrder = Number(selectedItem.variantList[0].variantMaxPerOrder);

        if (maxPerOrder > 0) {
          let itemqtyincart = selectedItem.variantList[0].variantQty;
          if (itemqtyincart >= maxPerOrder) {
            itemadderror = true;
          } else {
            itemadderror = false;
          }
        }
        if (itemadderror) {
          selectedItem.itemError = 'Limit exceeds perorder';
        } else {
          //update item quantity
          let newQuantity = selectedItem.quantity + 1;

          if (selectedItem.selectedDiscountId && selectedItem.discounted) {
            const discounts = this.settingService.getDiscounts();
            const selectedDiscount = discounts.find(x => x.discount_pkid === item.selectedDiscountId);
            if (selectedDiscount.limitReached) this.toastService.show(`Sorry, you’ve reached the maximum use for this discount`);


            let newItem = {
              ...selectedItem,
              guid: generateGuid(),
              discounted: true,
              addedByUser: false
            };
            if (selectedDiscount && selectedDiscount.applications[item.itemGuid] === selectedDiscount.discount_max_uses_per_order) {
              //const itemBeforeDicsount = selectedStore.storeCart.orderItemsBeforeDiscount.find(obj => obj.guid === item.guid);
              newItem = {
                ...selectedItem.originalItem,
                guid: generateGuid(),
                discounted: false,
                selectedDiscountId: 0,
                discountAmount: 0,
                addedByUser: false,
                originalItem: { ...selectedItem, guid: generateGuid() },
                quantity: 1
              };
            }

            newQuantity = 1;
            selectedStore.storeCart.orderItems.push(newItem);
            selectedItem = newItem;

            if (selectedItem.buyGetItems && selectedItem.buyGetItems.length) {

              selectedItem.buyGetItems.forEach(getItem => {
                getItem.parentGuid = item.guid;
                getItem.discounted = true;
                getItem.isFree = true;
                getItem.selectedDiscountId = item.selectedDiscountId;
                getItem.priceEach = 0;
                getItem.addedByUser = false;
                selectedStore.storeCart.orderItems.push(getItem);
              });
            }
            debugger
            this.updateMaxUsersPerOrder(newItem);
            selectedDiscount.limitReached = selectedDiscount.applications[item.itemGuid] === selectedDiscount.discount_max_uses_per_order;
            return;
          }
          selectedItem.quantity = newQuantity;
          selectedItem.variantList[0].variantQty = selectedItem.variantList[0].variantQty + 1;
          // update modifier quantity
          selectedItem.modifierSetList.forEach(modifierSet => {
            let setQuantity = modifierSet.quantity;
            modifierSet.modifierOptions.forEach(option => {
              if (option.optionSelected) {
                option.optionQuantity = option.optionQuantity + 1;
                setQuantity = setQuantity + 1;
              }
            });
            modifierSet.quantity = setQuantity;
          });


        }


      }
    } else {


      if (selectedItem.quantity === 1) {
        this.deleteItemFromCart(selectedItem, ind);
        return;
      }



      if (selectedItem && selectedItem.quantity > 1) {
        selectedItem.itemError = '';
        //update item quantity
        selectedItem.quantity = selectedItem.quantity - 1;
        selectedItem.variantList[0].variantQty = selectedItem.variantList[0].variantQty - 1;
        // update modifier quantity
        selectedItem.modifierSetList.forEach(modifierSet => {
          let setQuantity = modifierSet.quantity;
          modifierSet.modifierOptions.forEach(option => {
            if (option.optionSelected) {
              option.optionQuantity = option.optionQuantity - 1;
              setQuantity = setQuantity - 1;
            }
          });
          modifierSet.quantity = setQuantity;
        });
        // item amount
        // selectedStore.storeCart.orderItems[cartitemindex].totalPrice = selectedStore.storeCart.orderItems[cartitemindex].quantity * selectedStore.storeCart.orderItems[cartitemindex].priceEach;
        // selectedStore.storeCart.orderItems[cartitemindex].totalTax = selectedStore.storeCart.orderItems[cartitemindex].quantity * selectedStore.storeCart.orderItems[cartitemindex].taxEach;

        // item amount
        selectedItem.totalPrice = selectedItem.quantity * selectedItem.priceEach;
        selectedItem.totalPriceAfterDiscount = selectedItem.quantity * selectedItem.priceEachAfterDiscount;
        selectedItem.totalPriceBeforeDiscount = selectedItem.quantity * selectedItem.priceEachBeforeDiscount;

        let totalPrice = selectedItem.totalPrice;
        let totalPriceBeforeDiscount = selectedItem.totalPriceBeforeDiscount;
        let totalPriceAfterDiscount = selectedItem.totalPriceAfterDiscount;
        let priceDifference = totalPriceBeforeDiscount - totalPriceAfterDiscount;
        if (totalPriceBeforeDiscount == priceDifference) {
          selectedItem.totalDiscountAmount = 0;
        } else {
          selectedItem.totalDiscountAmount = totalPriceBeforeDiscount - totalPrice;

          // get the oadp discount for payouts
          // get the item 
          const taxtype = this.settings.company_sell_price_tax;
          let OADPOrderDiscountTotal = 0;

          let oadpItemVariant = item.variantList.find((obj) => {
            return obj.selected === true;
          });
          if (oadpItemVariant.variant_oadp) {
            if (this.serviceType === 'DINE_IN') {
              let oadpAmount = oadpItemVariant.variantDineInPrice - oadpItemVariant.variantDineInPriceDiscounted;
              if (taxtype === 'TAX_IN') {
                oadpAmount = Number(((oadpAmount * 100) / (oadpItemVariant.variantTaxRate + 100)).toFixed(2));
              }
              OADPOrderDiscountTotal = OADPOrderDiscountTotal + ((oadpAmount) * 1);
            }

          }

          item.modifierSetList.forEach(modiferset => {
            modiferset.modifierOptions.forEach(option => {
              if (option.optionSelected && option.option_oadp) {
                if (this.serviceType === 'DINE_IN') {
                  let oadpAmount = option.optionDineInPrice - option.optionDineInPriceDiscounted;
                  if (taxtype === 'TAX_IN') {
                    oadpAmount = Number(((oadpAmount * 100) / (option.optionTaxRate + 100)).toFixed(2));
                  }
                  OADPOrderDiscountTotal = OADPOrderDiscountTotal + oadpAmount;
                }
              }
            });
          });

          selectedStore.storeCart.orderDiscountTotalOADP = Number(selectedStore.storeCart.orderDiscountTotalOADP) - OADPOrderDiscountTotal;

        }

        selectedItem.totalTax = selectedItem.quantity * selectedItem.taxEach;
      }
    }
    // tax type based on company tax type selection made
    const taxtype = this.settings.company_sell_price_tax;
    let subTotal = 0;
    let TaxTotal = 0;
    let discountTotal = 0;
    selectedStore.storeCart.orderItems.forEach(item => {
      subTotal = subTotal + item.totalPrice;
      TaxTotal = TaxTotal + item.totalTax;
      discountTotal = discountTotal + item.totalDiscountAmount;
    });

    subTotal = Number(subTotal.toFixed(2));
    TaxTotal = Number(TaxTotal.toFixed(2));
    discountTotal = Number(discountTotal.toFixed(2));
    selectedStore.storeCart.orderSubTotal = subTotal;
    selectedStore.storeCart.orderDiscountTotal = discountTotal;
    selectedStore.storeCart.orderTax = TaxTotal;
    if (taxtype === 'TAX_IN') {
      selectedStore.storeCart.orderTotal = subTotal;
    } else {
      selectedStore.storeCart.orderTotal = subTotal + TaxTotal;
    }
    selectedStore.storeCart.orderTotal = Number(selectedStore.storeCart.orderTotal.toFixed(2));

    this.userSelectedStore = selectedStore;
    // update the quantity here for display
    // get all the item
    const cartitems = selectedStore.storeCart.orderItems.filter(x => x.itemGuid === item.itemGuid);
    let itemlistindex = -1;
    this.itemListAllCategory.find((obj, index) => {
      itemlistindex = index;
      return obj.item_pkid === item.itemGuid
    });
    if (itemlistindex !== -1) {
      let itemTotalQty = 0;
      cartitems.forEach(element => {
        itemTotalQty = itemTotalQty + element.quantity;
      });
      this.itemListAllCategory[itemlistindex].quantity = itemTotalQty;
    }


    this.webstorage.sessionSt_item_list = this.itemListAllCategory;

    // update back to local storage
    this.userServiceBase.selectedStoreServiceList[userStoreIndex] = selectedStore;
    this.settingService.setUserSerivce(this.userServiceBase);

    if (this.userSelectedStore && this.userSelectedStore.storeCart) {
      this.getTotalAmountToPay(this.userSelectedStore.storeCart.orderTotal, 'onItemClick');
    } else {
      this.getTotalAmountToPay(0, '');
    }
  }



  // Method to handle the delete item from cart
  deleteItemFromCart(item: ItemBase, ind) {
    if (item.discounted) this.updateMaxUsersPerOrder(item, false);

    if (item.hasReward) {
      this.customerLoyalty.points = this.customerLoyalty.points + item.reward.point;

      this.settingService.setUserInfo(this.customerLoyalty);

      const selectedRewards = this.userSelectedStore.storeCart.orderItems.filter(item =>
        item.hasReward).map(x => x.reward);
      if (selectedRewards.length === this.customerLoyalty.maxUses) {
        this.activeRewards.forEach(r => {
          r.is_redeemed = false;
        })
      }

      const reward = this.activeRewards.find(x =>
        x.reward_pkid === item.reward.reward_pkid &&
        x.item_pkid === item.reward.item_pkid);
      if (reward) {
        reward.is_redeemed = false;
        this.activeRewards = [...this.activeRewards];
      }
    }

    //console.log('deleteItemFromCart' + item.ItemVariantModifierSetOptionGuid);
    this.cartEmptyMessage = '';
    this.cartErrorMessage = '';
    let serviceActiveId = this.webstorage.sessionSt_service_active_id;
    if ((this.webstorage.sessionSt_qr_code_scanned && this.webstorage.sessionSt_qr_code_scanned) || (this.webstorage.sessionSt_weburl_order && this.webstorage.sessionSt_weburl_order)) {
      serviceActiveId = 1;
    }
    // filter the location based cart
    let userStoreIndex = -1;
    const selectedStore = this.userServiceBase.selectedStoreServiceList.find((obj, index) => {
      userStoreIndex = index;
      return obj.locationPkid === this.locationSelected.mm_online_order_location_settings.ools_location_pkid && obj.serviceType === this.serviceType && !obj.serviceCompleted;
    });
    let cartitemindex = -1;
    // const selectedItem = selectedStore.storeCart.orderItems.find((obj, index) => {
    //   cartitemindex = index;
    //   return this.ecomservice.stringCompare(obj.itemGuid, item.itemGuid) && this.ecomservice.stringCompare(obj.variantList[0].variantGuid, item.variantList[0].variantGuid) && item.itemId === obj.itemId;
    // });
    //console.log('------------------');
    //console.log(selectedStore.storeCart.orderItems);
    //console.log('------------------');
    const selectedItem = selectedStore.storeCart.orderItems.find((obj, index) => {
      cartitemindex = index;
      return obj.guid === item.guid;
    });
    if (selectedItem) {
      selectedStore.storeCart.orderItems.splice(cartitemindex, 1);
    }

    if (item.discounted || item.hasReward) {
      selectedStore.storeCart.orderItems = selectedStore.storeCart.orderItems.filter(obj => obj.parentGuid !== item.guid);
    }



    this.userSelectedStore = selectedStore;
    if (!this.userSelectedStore.storeCart.orderItems.length) {

      const message = this.translate.instant('CART_PAGE.CART_EMPTY');
      this.cartEmptyMessage = message;
    }
    // update back to local storage
    this.userSelectedStore = selectedStore;
    this.userServiceBase.selectedStoreServiceList[userStoreIndex] = selectedStore;
    this.settingService.setUserSerivce(this.userServiceBase);
    //this.getTaxList(this.userServiceBase.selectedStoreServiceList[userStoreIndex].storeCart.orderItems, this.userServiceBase.selectedStoreServiceList[userStoreIndex].storeCart.orderDeliveryCharge);
    if (this.userSelectedStore && this.userSelectedStore.storeCart) {
      this.getTotalAmountToPay(this.userSelectedStore.storeCart.orderTotal, 'deleteItemFromCart');
    } else {
      this.getTotalAmountToPay(0, '');
    }
  }

  confirmDelete(item: ItemBase, index: number) {
    if (item.discounted) {
      this.discountWarningRef = this.modalService.show(this.discountWarning, this.configorderstatus);
      this.handleGoAhead = () => {
        this.deleteItemFromCart(item, index);
      };
      return;
    }

    this.deleteItemFromCart(item, index);
  }

  updateMaxUsersPerOrder(item: ItemBase, isIncrease = true) {
    const discounts = this.settingService.getDiscounts();
    const selectedDiscount = discounts.find(x => x.discount_pkid === item.selectedDiscountId);

    if (!selectedDiscount || selectedDiscount.applications[selectedDiscount.discount_pkid] === 0) return;

    const currentApplicationCount = selectedDiscount.applications[selectedDiscount.discount_pkid] || 0;

    // Update the application count based on the isIncrease flag
    const newApplicationCount = isIncrease ? currentApplicationCount + 1 : currentApplicationCount - 1;

    // Ensure the new count is not negative
    selectedDiscount.applications[selectedDiscount.discount_pkid] = Math.max(newApplicationCount, 0);

    // Update availability status based on the new application count
    selectedDiscount.isAvailable = selectedDiscount.applications[selectedDiscount.discount_pkid] > 0;
    selectedDiscount.limitReached = selectedDiscount.applications[selectedDiscount.discount_pkid] === selectedDiscount.discount_max_uses_per_order;
    this.settingService.setDiscounts(discounts);
  }


  // Method to get the order id
  getOrderID() {
    // Company, location, day, month, year,hour,minutes,seconds,milliseconds
    const day = new Date().getDate() + 1;
    const month = new Date().getMonth() + 1;
    // const yearlength = new Date().getFullYear().toString().length;
    const year = new Date().getFullYear().toString().substr(2);
    const hour = new Date().getHours();
    const minute = new Date().getMinutes();
    const second = new Date().getSeconds();
    const milliseconds = new Date().getMilliseconds();
    const orderId = '' + day + month + year + hour + minute + second + milliseconds;
    return orderId;
  }

  // Method to handle the menuitem click event
  onMenuItemsClick() {
    this.settingService.setUserSerivce(this.userServiceBase);
    this.webstorage.sessionSt_frompage = 'cart';
    this.router.navigate(['items', this.webstorage.sessionSt_company_clicked]);
  }

  onCheckoutClick() {
    this.onCheckoutClick1();
  }

  // Method to handle the checkout click event
  onCheckoutClick1() {
    this.updateRewardPoints();
    this.active = 1;

    // company QR

    if (!this.usertoken && this.qrCodeType === 3) {
      this.webstorage.sessionSt_frompage = 'cart';
      this.router.navigate(['login']);
      return;
    }
    let sessionExpired = false;
    //first check for cart expired?
    if (this.userServiceBase && this.userServiceBase.serviceCartStarteddAt) {
      let date1 = new Date().getTime();
      let date2 = new Date(this.userServiceBase.serviceCartStarteddAt).getTime();
      let time = date1 - date2;  //msec
      let minutesDiff = Math.floor(time / 60000);
      minutesDiff = Number(minutesDiff.toFixed(0));
      //console.log('mins diff cart - ' + minutesDiff);
      let cartExpireInMins = Number(this.ecomservice.GetOlarConfigValue('cartexpiryInMins'));
      if (minutesDiff >= cartExpireInMins || NaN) {
        this.active = 0;
        //sessionExpired = true;
        //this.sessionModalRef = this.modalService.show(this.sessionExpired, this.configsessionExpired);
      }
    }

    if (!sessionExpired) {
      let serviceActiveId = this.webstorage.sessionSt_service_active_id;
      if ((this.webstorage.sessionSt_qr_code_scanned && this.webstorage.sessionSt_qr_code_scanned === true) || (this.webstorage.sessionSt_weburl_order && this.webstorage.sessionSt_weburl_order === true)) {
        serviceActiveId = 1;
      }
      let userStoreIndex = -1;
      let selectedStore = this.userServiceBase.selectedStoreServiceList.find((obj, index) => {
        userStoreIndex = index;
        return obj.locationPkid === this.locationSelected.mm_online_order_location_settings.ools_location_pkid && !obj.serviceCompleted && obj.serviceType === this.serviceType;
      });

      const taxtype = this.settings.company_sell_price_tax;

      this.cartEmptyMessage = '';
      this.cartErrorMessage = '';
      this.userServiceBase.serviceCheckoutStartedAt = new Date();
      if (this.surcharges.length) {
        this.userServiceBase.surcharges = this.surcharges.map(x => x.surcharge_pkid);
      }
      if (this.entireDiscount && !this.entireDiscount.rewardPkid) {
        this.userServiceBase.order_level_discount = {
          disc_name: "",
          disc_percentage: this.entireDiscount.discount_value,
          disc_pkid: this.entireDiscount.discount_pkid,
          disc_source: "AUTO"
        };
      }
      const userService = this.settingService.getUserSerivce();
      this.userServiceBase.customer_loyalty_pointbase = {
        soclp_customer_pkid: this.customerLoyalty.userPkid,
        soclp_sales_order_amount: this.userSelectedStore.storeCart.orderTotal,
        soclp_gained_points: userService.gainedPoints,
        soclp_spent_points: 0,
        soclp_spent_with_points: 0,
        customer_benefit_counts: []
      };

      if (this.customerLoyalty.userPkid > 0) {
        const rewardItems = this.userSelectedStore.storeCart.orderItems
          .filter(item => item.hasReward);

        if (rewardItems.length) {
          const res = [];
          rewardItems.forEach(rItem => {

            let amount = rItem.quantity * rItem.discountAmount;
            const reward = {
              loyalty_reward_pkid: rItem.reward.reward_pkid,
              loyalty_reward_name: rItem.reward.name,
              loyalty_benefit_count_pkid: 0,
              loyalty_customer_reward_pkid: rItem.reward.customer_reward_pkid,
              loyalty_reward_type: rItem.reward.type,
              loyalty_discount_percentage: 0,
              loyalty_discount_amount: amount,
              loyalty_total_tax: 0,
              loyalty_spent_points: rItem.reward.point
            };
            if (rItem.reward.type === "BENEFIT_COUNT") {
              reward.loyalty_benefit_count_pkid = rItem.reward.benefit_count_pkid;
            }
            res.push(reward);
          })
          this.userServiceBase.loyalties = res;
        }

        const itemsHaveBenefit = this.userSelectedStore.storeCart.orderItems.filter(item =>
          !item.hasReward &&
          !item.discounted &&
          item.variantList &&
          item.has_benefit_count
        );

        const variantPkids = itemsHaveBenefit
          .map(item => item.variantList && item.variantList.length > 0
            ? item.variantList[0].variantGuid
            : null)
          .filter(id => id !== null);


        if (variantPkids.length) {

          const benefitList = [];
          var benefitRewards = this.allrewards.filter(x => x.type === "BENEFIT_COUNT" && !x.is_assigned);

          benefitRewards.forEach(benefit => {
            const items = itemsHaveBenefit.filter(item =>
              item.variantList.length > 0 &&
              benefit.item_pkid === +item.variantList[0].variantGuid)
            const totalQuantity = items.reduce((sum, item) => sum + item.quantity, 0);
            benefitList.push({
              socbc_lt_pkid: benefit.reward_pkid,
              socbc_count: totalQuantity
            });
          });

          const map = {};

          benefitList.forEach(item => {
            if (!map[item.socbc_lt_pkid]) {
              map[item.socbc_lt_pkid] = { ...item };
            } else {
              map[item.socbc_lt_pkid].socbc_count += item.socbc_count;
            }
          });

          const merged = Object.values(map);

          const customer_loyalty_pointbase = this.userServiceBase.customer_loyalty_pointbase as any;

          customer_loyalty_pointbase.soclp_customer_pkid = this.customerLoyalty.userPkid;
          customer_loyalty_pointbase.soclp_sales_order_amount = this.userSelectedStore.storeCart.orderTotal;
          customer_loyalty_pointbase.soclp_gained_points = userService.gainedPoints;
          customer_loyalty_pointbase.soclp_spent_points = 0;
          customer_loyalty_pointbase.soclp_spent_with_points = 0;
          customer_loyalty_pointbase.customer_benefit_counts = merged.filter((x: any) => x.socbc_count > 0);

        }

        if (this.entireDiscount && this.entireDiscount.rewardPkid) {
          const re = this.activeRewards.find(x => x.reward_pkid === this.entireDiscount.rewardPkid)
          if (re) {
            this.userServiceBase.order_level_reward = {
              pkid: re.reward_pkid,
              name: re.name,
              benefitCountPkid: re.benefit_count_pkid,
              valueType: re.value_type,
              value: re.reward_value,
              amount: this.totalEntireDiscounts,
              benefitCountRemaining: 0,
              benefitCountSocbcCount: 0,
              pointToRedeem: re.point,
              maxAmount: re.value_type === "AMOUNT" ? 0 : re.max_value,
              maxTimePerOrder: 1,
              customerRewardPkid: re.customer_reward_pkid
            };
            const userService = this.settingService.getUserSerivce();
            userService.spentsPoints += re.point;
          }
        }
      }


      this.settingService.setUserSerivce(this.userServiceBase);
      if (this.userSelectedStore.storeCart && this.userSelectedStore.storeCart.orderItems && this.userSelectedStore.storeCart.orderItems.length > 0) {

        // check for item qty atleast one should be there
        let isQtyZero = false;
        for (let i = 0; i < this.userSelectedStore.storeCart.orderItems.length; i++) {
          const cartItem = this.userSelectedStore.storeCart.orderItems[i];
          if (cartItem.quantity === 0) {
            this.userSelectedStore.storeCart.orderItems[i].itemError = 'Qty Zero';
            isQtyZero = true;
            break;
          }
        }
        if (isQtyZero) {
          this.cartErrorMessage = 'Cannot checkout zero qty item!';
          this.active = 0;
        } else {
          if (this.userSelectedStore.storeCart.orderTotal > 0) {
            // if the service type is collection then check for min order amount
            if (this.serviceType === 'COLLECTION') {
              const minOrderAmt = this.locationSelected.mm_online_order_location_settings.ools_collection_min_order_amount;
              if (this.userSelectedStore.serviceType === this.serviceType && this.userSelectedStore.storeCart.orderTotal < minOrderAmt) {
                let minOrderAmount = '';
                if (this.settings && this.settings.company_currency_position === 'BACK') {
                  minOrderAmount = this.settings.company_currency + ' ' + minOrderAmt;
                } else {
                  if (this.settings.company_currency_position === 'FRONT') {
                    minOrderAmount = minOrderAmt + ' ' + this.settings.company_currency;
                  } else {
                    minOrderAmount = minOrderAmt + ' ' + this.settings.company_currency;
                  }
                }
                this.cartErrorMessage = 'Collection minimum order amount should be ' + minOrderAmount;
                return;
              } else {
                this.webstorage.sessionSt_frompage = 'cart';
              }
            } else if (this.serviceType === 'DELIVERY') {

            } else {
              this.webstorage.sessionSt_frompage = 'cart';
            }
          } else {
            /*
            *
            * as per the discussion with raj sir people can do checkout for zero priced item
            * scenario in case of roomservice can order for bucket of ice or sugar or water like free service items
            * 
            this.cartErrorMessage = 'Cart total should be greater than zero price';
            */
            this.webstorage.sessionSt_frompage = 'cart';
          }


          this.router.navigate(['checkout', 'review']);

        }
      } else {
        this.active = 0;
        const message = this.translate.instant('CART_PAGE.EMPTY_WITH_ACTION');
        this.cartEmptyMessage = message;
      }
    }
  }



  closePromo() {
    this.modalRef.hide();
    //$('.modal').css({"display": "none"});
  }


  onSignInClick() {
    //this.saveUserDeliveryDetailsLocally();
    this.webstorage.sessionSt_frompage = 'cart';
    this.router.navigate(['login']);
  }

  checkValue(value) {
  }

  onSessionExpired() {
    this.sessionModalRef.hide();
    //$('.modal').css({"display": "none"});
    this.webstorage.clear('localst_userservicerequest', 'LOCAL');
    //localStorage.clear();
    this.router.navigate(['home'])
  }

  getOrderDatetimeFormat(orderDateTime): any {
    let orderDateTimeArray = orderDateTime.split(' ');
    let datetime = orderDateTimeArray[1] + ' ' + orderDateTimeArray[2];
    let today = new Date();
    let day = today.getDate() + '';
    day = this.checkZero(day)
    let month = (today.getMonth() + 1) + '';
    let year = today.getFullYear() + '';
    let hour = today.getHours() + '';
    let minutes = today.getMinutes() + '';
    let seconds = today.getSeconds() + '';

    let orderDateArray = orderDateTimeArray[0].split('-');
    const monthNames = ["Jan", "Feb", "March", "April", "May", "June",
      "July", "Aug", "Sept", "Oct", "Nov", "Dec"
    ];
    let monthname = monthNames[Number(orderDateArray[1]) - 1];
    if (day !== orderDateArray[2]) {
      day = this.checkZero(day);
      datetime = datetime + ',' + orderDateArray[2] + ' ' + monthname;
    } else {
      datetime = datetime + ', Today';
    }
    return datetime;
  }


  // Method to handle the alert close event
  onClosed(dismissedAlert: AlertComponent): void {
    this.alerts = [];
  }

  customSearchFn(term: string, item: any) {
    return true;
  }



  openRewardTermsModal() {
    this.rewardTermsModalRef = this.modalService.show(this.rewardTermsModal, { class: 'modal-dialog-centered' });
  }

  okRewardTerms() {
    this.rewardTermsModalRef.hide();
  }

}
